import * as React from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
import Hero from "../components/hero";

const IndexPage = () => (
  <Layout>
    <Seo title="Home" />
    <div className="text-black dark:text-white">
      <h1 className="py-10 text-xl">Hi people</h1>
      <p className="pb-10">
        Welcome to my site for learning to make charts
        </p>
      <div className="grid grid-cols-2 gap-4">
        <Hero text='Bar Charts' url="/bar" />
        <Hero text='Scattered Plot' url="/scatter" />
        <Hero text='Pies' url="/pie" />
        <Hero text='Map' url='/map' />
      </div>
    </div>
  </Layout>
)

export default IndexPage
